// extracted by mini-css-extract-plugin
module.exports = {"catering_faq_container":"_2ORZn"};